module.exports = require("@trycourier/courier-react-native");